// removed by extract-text-webpack-plugin
module.exports = {"container":"_4zxg4kmnzustkc8ewq9yxbt5ckh4y6ft5u8vcve6uk2w2u94x7jyvhyqun7g3dp67bxrrcn6b8bspd99vxe5bmzcukpeg911gcatqef-Avatar-module-container","border":"_28rx9uqwymc6fnxx1b1rvgkgkaaqgssz9mpjfu89yme4u2mv2eqvr3dnmejmd1uesnskxka6gdmg3emy3eqxahsmf2rxs7b7ngtc9rh-Avatar-module-border","image":"_4nqxspj8db4as1nvatwyd8mrqkhdemuwdqr91s2vk89m4ezqezzvdyytkdeg5b2deru57tcqqbzxmj8hc3q7g687bp7kfab7g8hx5y1-Avatar-module-image"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/Avatar.module.css
// module id = 137
// module chunks = 0